import { render, staticRenderFns } from "./ProductMappingTable.vue?vue&type=template&id=3458a73d&scoped=true"
import script from "./ProductMappingTable.vue?vue&type=script&lang=js"
export * from "./ProductMappingTable.vue?vue&type=script&lang=js"
import style0 from "./ProductMappingTable.vue?vue&type=style&index=0&id=3458a73d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3458a73d",
  null
  
)

export default component.exports